















import { View } from 'client-website-ts-library/plugins';
import { Component, Mixins, Vue } from 'vue-property-decorator';

@Component
export default class About extends Mixins(View) {}
